<template>
  <div ref="editorDOM">
    <div class="windowInfoWrap m-main" ref="innerDOM">
      <div class="topBox boxshadow">
        <div class="left">
          <div class="main">
            {{
              "您预约" + deptName + doctorName + "医生" + orderTime + "挂号成功"
            }}
          </div>
          <div class="txt">请于30分钟内完成支付，如在有效期内未完成支付，将自动为您取消预约</div>
        </div>
        <div class="right">
          <div class="payable">应付金额：</div>
          <div class="money">{{ totalFee }}元</div>
        </div>
      </div>
      <div class="bottom boxshadow">
        <div class="bg"></div>
        <div class="left">支付方式：</div>
        <div class="right">
          <div class="payType">
            <div
              :class="showWeChatFlag == true ? 'wechat now' : 'wechat'"
              @click="showWeChat()"
            >
              <img src="../images/wechat_pay.svg" alt="" srcset="" />
              <div v-if="showWeChatFlag == true" class="rightbottom">
                <img src="../images/choose_payment.svg" alt="" srcset="" />
              </div>
            </div>
            <div
              :class="showWeChatFlag == false ? 'alipay now' : 'alipay'"
              @click="hiddenWeChat()"
            >
              <img src="../images/ali_pay.svg" alt="" srcset="" />
              <div v-if="showWeChatFlag == false" class="rightbottom">
                <img src="../images/choose_payment.svg" alt="" srcset="" />
              </div>
            </div>
          </div>
          <div class="qrcode"><img :src="qcodeImg" alt="" srcset="" /></div>

          <div class="detail">
            距离二维码过期还剩
            <span style="colorr: #F93E3E;" id="time">{{ num }} </span
            >秒，过期后请刷新页面重新获取二维码
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "hospital-payQrCode-001",
  data() {
    return Object.assign(
      {
        deptName: "普外科门诊",
        doctorName: "刘傲",
        orderTime: " 2021年4月14日 上午 10：00-11：00",
        totalFee: "150.5",
        qcodeImg: require("../images/ali_pay.svg"),
        num: 60,
        showWeChatFlag: true,
        timer: ""
      }
    );
  },
  mounted() {
    this.timer = setInterval(this.clock, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    showWeChat() {
      this.showWeChatFlag = true;
    },
    hiddenWeChat() {
      this.showWeChatFlag = false;
    },
    clock() {
      if (this.num > 0) {
        this.num--;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.boxshadow {
  background: #ffffff;
  box-shadow: 0px 0.04rem 0.2rem 0px #f5f5f5;
  border-radius: 0.04rem;
}
.windowInfoWrap {
  .topBox {
    padding: 0.4rem 0.66rem 0.39rem 0.4rem;
    .left {
      .main {
        font-size: 0.18rem;
        color: #222222;
        font-weight: 400;
      }
      .txt {
        margin-top: 0.18rem;
        font-size: 0.16rem;
        color: #999999;
        font-weight: 400;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .payable {
        font-size: 0.2rem;
        color: #333333;
        font-weight: 400;
      }
      .money {
        font-size: 0.26rem;
        color: #f29e0c;
        font-weight: 400;
      }
    }
  }
  .bottom {
    position: relative;
    margin-top: 0.4rem;
    padding: 0.6rem 0 0.96rem 0.4rem;
    justify-content: flex-start;
    .bg {
      width: 6.38rem;
      height: 4.9rem;
      position: absolute;
      right: 0;
      bottom: 0;
      background: url(../images/pay_bg_img.png) no-repeat center;
    }
    .left {
      font-size: 0.2rem;
      color: #333333;
      font-weight: 400;
    }
    .right {
      margin-left: 0.36rem;
      .payType {
        display: flex;
        .now {
          border: 2px solid #28b66d !important;
        }
        .wechat {
          position: relative;
          padding: 0.16rem 0.24rem;
          width: 1.8rem;
          border: 1px solid #dfdfdf;
          border-radius: 4px;
          img {
            width: 1rem;
          }
          .rightbottom {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 0.36rem;
            img {
              width: 100%;
            }
          }
        }
        .alipay {
          position: relative;
          padding: 0.16rem 0.24rem;
          width: 1.8rem;
          margin-left: 0.16rem;
          border: 1px solid #dfdfdf;
          border-radius: 4px;
          img {
            width: 1rem;
          }
          .rightbottom {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 0.36rem;
            img {
              width: 100%;
            }
          }
        }
      }
      .qrcode {
        margin-top: 0.4rem;
        width: 0.32rem;
        border: 1px solid #dfdfdf;
        width: 3.2rem;
        height: 3.2rem;

        img {
          width: 100%;
        }
      }
      .detail {
        width: 3.2rem;
        margin-top: 0.3rem;
        background: rgba(249, 62, 62, 0.1);
        border: 1px solid #f93e3e;
        border-radius: 4px;
        padding: 0.09rem 0.24rem;
        font-size: 0.16rem;
        color: #675858;
        line-height: 0.24rem;
        font-weight: 400;
      }
    }
  }
}
.m-screen-pc {
  .topBox {
    display: flex;
    justify-content: space-between;
  }
  .bottom {
    display: flex;
  }
}
.m-screen-mobile {
  padding: 0 0.25rem !important;
  margin-top: 0.8rem !important;
  margin-bottom: 1rem !important;
  .topBox {
    padding: 0.4rem 0.3rem;
    .right {
      margin-top: 0.2rem;
    }
  }
  .bottom {
    .bg {
      width: 0;
    }
    .right {
      margin-top: 0.2rem;
      margin-left: 0;
      .payType {
        justify-content: center;
      }
      .qrcode {
        margin-left: auto;
        margin-right: auto;
      }
      .detail {
        width: 100%;
      }
    }
  }
}
</style>
